module.exports = __webpack_public_path__ + "img/female_avartar.058823e4.png";